<template>
  <div>
    <div v-if="actionCount > 0">
      <user-editor-test-box v-on:addMultiVal="addMultiVal" v-bind:showOrNot="showOrNot" v-bind:actionCount="actionCount" v-bind:multiFormIndex="multiFormIndex"/>

    </div>


    <input
        type="text"
        class="form-control"
        :placeholder="apiSetting.label"
        :name="apiSetting.keys"
        v-model="apiSetting.multibox"
        v-on:keyup.13="addMultiVal('')"
        @click="showMultiList()"
    />
    <!--                              {{workflowStore.workflowsS[actionCount].api.design.forms[index].value}}-->
<!--    <input v-model="$store.state.workflowStore.workflowsS[actionCount].api.design.forms[multiFormIndex].value"  />-->
    <small>원하는 값을 작성한 후 엔터를 눌러주세요.</small>
    <br>
    <span
        v-for="(val, valI) in tagVal"
        :key="valI"
        class="tag badge badge-info"
        style="margin: 3px 5px 0px 0px; font-size: 14px;"

    >
    {{ val }}
    <span
        @click="removeMultiVal(valI)"
        style="margin: 0px 2px 0px 8px"
    >
      x
    </span>
  </span>

    <!--    testData 가져와서 multiList 보여주기-->


<!--    <span>-->
<!--      <ul-->
<!--        id="multiList"-->
<!--        v-if="-->
<!--          userStore.testData.length != 0 && showMultiListCode == multiFormIndex-->
<!--        "-->
<!--      >-->
<!--        &lt;!&ndash; testData에 같은 값들이 계속 추가돼서 우선 0으로 고정해서 표시되도록 함 &ndash;&gt;-->
<!--        <li v-for="(mVal, index) in userStore.testData[0].value" :key="index" @click="addMultiVal(mVal)">-->
<!--          <span style="font-size: 18px">{{ index }}</span-->
<!--          ><span style="font-size: 14px">({{ mVal }})</span>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </span>-->
</div>

</template>

<script>
import UserEditorTestBox from "@/views/user/editor/UserEditorTestBox";
export default {
  components: {UserEditorTestBox},
  props : ['multiFormIndex','actionCount'],
  data() {
    return{
      apiSetting : {},
      tagVal : [],
      showMultiListCode: null,

      showOrNot : false,
    }
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
  },


  methods: {

    addMultiVal(str, from, apiNum) {
      // console.log("ㅇㅇㅇㅇㅇ",this.$store.state.workflowStore.workflowsS[i].api.design.forms[formI].value )
      console.log("ㅇㅇㅇㅇㅇ", str )

      var text = "";

      if(str != "" && from == null) {
        text = str
      } else if(str != "" && from == 'testData') {

        console.log("test data : ", this.$store.state.userStore.testData)

        var name = this.$store.state.userStore.testData[apiNum].key


        text = "{#" + name + "." + str + "}";

        this.showOrNot = false;
      } else {
        text = this.apiSetting.multibox;
      }

      console.log(text ,",test text")
      // var valArr = [];
      var workflowForm = this.$store.state.workflowStore.workflowsS;
      //
      // this.$store.state.workflowStore.workflowsS[i].api.design.forms[index].value = originText
      //
      //  console.log(originText)

      if(workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value != undefined){

        if(workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value.length == 0){
          workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value = text



          console.log(workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value)
        } else {
          var originText = workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value
          workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value = originText + "," + text;



        }
      } else {
        workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value = text
      }

      console.log(workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value.length)




      this.tagVal.push(text);
      this.apiSetting.multibox = ''

      // this.$store.dispatch("saveWorkflowForm", workflowForm);
      // this.updateWorkflow();
    },

    removeMultiVal(index) {
      var rmText = this.tagVal[index]
      console.log(rmText)

      console.log("삭제전 : ",this.tagVal)

      this.tagVal.splice(index, 1);

      console.log("삭제되고 남은 : ",this.tagVal)

      var workflowForm = this.$store.state.workflowStore.workflowsS;

      console.log(workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value)

      // var long = workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value;
      // long.replace(/rmText/gi, '');


      var str = ""
      if(this.tagVal.length > 0){
        for(var i = 0 ; i < this.tagVal.length; i++){


            if(str == ""){
              str = this.tagVal[i]
            } else {
              str = str + ","+ this.tagVal[i]
            }



        }

      } else {


        str = workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value.replace(rmText, "");

        if(str.indexOf(",,") > -1){
          str = str.replace(",,", ",")
        }

        console.log(workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value)



      }


      workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value = str
      console.log(workflowForm[this.actionCount].api.design.forms[this.multiFormIndex].value)



      this.$store.dispatch("saveWorkflowForm", workflowForm);
      // this.updateWorkflow();
    },

    showMultiList() {
      console.log("ddd", this.showOrNot)

      this.showOrNot = !this.showOrNot;



      // if(this.showMultiListCode == null || this.showMultiListCode != formI) {
      //   this.showMultiListCode = formI;
      //   return;
      // }
      //
      // if(this.showMultiListCode == formI) {
      //   this.showMultiListCode = null
      //   return;
      // }

    },

    addWorkflowValue(value, one, two) {
      console.log(value, one, two)
      // console.log("dsfsdds", this.apiSettingList[two])$store.state.workflowStore.workflowsS[actionCount].api.design.forms[multiFormIndex].value
      console.log("dsfsdds", this.$store.state.workflowStore.workflowsS[one].api.design.forms[two])


      //있는 경우
      // if(value != null){
      console.log(value.length)

      var originText = this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value
      var finalText = "";


      console.log(originText.indexOf("[{"))


      if (originText.indexOf("[{") > -1) {

        var end = originText.indexOf("}]");

        finalText = originText.substr(end + 3);

      } else {
        finalText = originText
      }

      console.log(value,value.length,  finalText)

      if(finalText.indexOf(',,') > -1){

        finalText = finalText.replace(/,,/gi, ',');
      }



      if (value.length > 0) {
        this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value = JSON.stringify(value) + "," + finalText
      } else {
        this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value = finalText
      }


      console.log(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex].value)


    }


  },
  created(){
    console.log("userEditorMultiBoxs.created")

    console.log(this.multiFormIndex)
    console.log(this.actionCount)


    var flowData = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex]

    this.apiSetting.key = flowData.keys
    this.apiSetting.label = flowData.label
    this.apiSetting.multibox = ''



    if(flowData.multi == 1){

      var valdata = flowData.value;


      if(valdata.indexOf("[{") > -1){
        // var start = flowData.value.indexOf("[{")
        var end = flowData.value.indexOf("}]")

        valdata = flowData.value.substr(end+3);

      }



      if(valdata != undefined || valdata != ''){
        var datas = valdata.split(",")
        for(var i = 0; i < datas.length; i++){

          if(datas[i].length > 1){
            this.tagVal.push(datas[i])

          }



        }

      }
    }





  }
};
</script>


